import { useState, useEffect } from 'react';
import Button from '../shared/Button';
import { X } from 'lucide-react';

const styles = {
	section: 'fixed inset-0 z-[9999] flex items-center justify-center p-4',
	backDrop: 'absolute inset-0 bg-black/70',
	// modal: 'relative z-10 w-full max-w-[500px] rounded-[18px] bg-white shadow-2xl p-[30px] max-h-[90vh] overflow-y-auto',
	modal: 'relative z-10 w-full max-w-[500px] rounded-[18px] bg-white shadow-2xl p-[30px] max-h-[90vh] flex flex-col',
	heading: 'text-25 font-bold text-dark-blue mb-3 leading-100',
	subHeading: 'text-gray text-sm mb-8',
	label: 'text-[22px] leading-100 font-semibold text-dark-blue mb-[15px]',
	solutionLabel: 'text-[22px] leading-100 font-semibold text-dark-blue'
};

export default function SendMessageModal({
	isOpen,
	onClose,
	isImported,
	/** selected query object */
	query,
	/** called when user clicks "Send message" with the entered solution */
	onSend
}) {
	const [solution, setSolution] = useState('');

	useEffect(() => {
		if (isOpen) {
			setSolution(query?.solution || '');
		}
	}, [isOpen, query]);

	if (!isOpen || !query) return null;

	const isPending = query.status === 'PENDING';

	const handleBackdropClick = (e) => {
		if (e.target === e.currentTarget) onClose();
	};

	return (
		<div className={styles.section} onClick={handleBackdropClick}>
			{/* Backdrop */}
			<div className={styles.backDrop} />

			{/* Modal */}
			<div className={styles.modal}>
				{isImported && (
					<div className="w-14 h-7 p-2 rounded-[8px] bg-[#F2F3F7] mb-3">
						<p className="text-xs font-medium text-dark-blue">Step 2</p>
					</div>
				)}
				<button
					onClick={onClose}
					className="absolute top-8 right-4 md:right-6 w-5 h-5 bg-dark-blue/40 hover:bg-dark-blue/80 rounded-full flex items-center justify-center transition-colors"
				>
					<X className="w-3 h-3 text-white" />
				</button>

				{/* Heading */}
				<h2 className={styles.heading}>{query.query_id}</h2>
				<p className={styles.subHeading}>{query.email}</p>

				<div className="h-[1px] bg-[#F0F0F0] mb-[30px] mx-[-30px]" />

			<div className="flex-1 overflow-y-auto">
				{/* User message and Solution */}
				<div className="grid grid-cols-1 gap-6 mb-5">
					<div>
						<p className={styles.label}>User message:</p>
						<p className="text-20 leading-100 italic font-medium text-dark-blue">
							“{query.message}”
						</p>
					</div>

					<div className="h-[1px] bg-[#F0F0F0] mb-[30px]" />

					{/* Pending: input; Solved: show solution */}
					{isPending ? (
						<div>
							<div className="flex items-center gap-2 mb-3">
								<label htmlFor="solution" className={styles.solutionLabel}>
									Type solution here:
								</label>
							</div>
							<textarea
								id="solution"
								placeholder="Type your solution…"
								value={solution}
								onChange={(e) => setSolution(e.target.value)}
								className="w-full rounded-[10px] border-1p3 border-lightGrey px-4 py-3 text-lg text-dark-blue"
							/>
						</div>
					) : (
						<div>
							<p className={styles.label}>Solution</p>
							<p className="text-20 leading-100 italic font-medium text-dark-blue">
								{query.solution ? `“${query.solution}”` : '—'}
							</p>
						</div>
					)}
				</div>
			</div>
				<div className="h-[1px] bg-[#F0F0F0] mb-[30px] mx-[-30px]" />

				{/* Buttons */}
				<div className="flex gap-3">
					{isPending ? (
						<Button onClick={() => onSend?.(solution.trim())} disabled={!solution.trim()}>
							Submit
						</Button>
					) : (
						<Button onClick={onClose}>Cancel</Button>
					)}
				</div>
			</div>
		</div>
	);
}
